<template>
	<div :class="[companyClass, canScroll]" v-show="userPermissionsFilter.smallworldReport">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<div class="page-header">
				<h1 class="pageTitle">SmallWorld Transactions</h1>
				<h4>Setting &amp; Reports</h4>
			</div>
			<div class="toolbar-box flex">
				<div class="search-box box grow">
					<div><i class="mdi mdi-magnify"></i></div>
					<input v-model="search" placeholder="Search..." />
				</div>
				<div class="pagination-box animated fadeInRight">
					<div class="select-box">
						<el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini">
							<el-option value="10" label="10"></el-option>
							<el-option value="15" label="15"></el-option>
							<el-option value="20" label="20"></el-option>
							<el-option value="30" label="30"></el-option>
							<el-option value="50" label="50"></el-option>
							<el-option value="100" label="100"></el-option>
						</el-select>
					</div>
					<div class="label"> /page</div>
				</div>
				<div class="csv-box animated fadeInRight">
					<button @click="downloadData">download csv ({{ total }})</button>
				</div>
			</div>

			<resize-observer @notify="handleResize" />

			<div class="table-box card-base card-shadow--medium box grow" id="table-wrapper"
				v-loading="!asyncComponent">
				<div :style="{ 'width': width + 'px' }">
					<!-- v2-table -->
					<component :is="asyncComponent" ref="table" :data="list" :height="height" :border="false"
						:total="total" :lazy-load="false" :loading="loading" class="styled" :class="{ 'mobile': isMobile }"
						@page-change="handlePageChange" :pagination-info="paginationInfo"
						:default-sort="{ prop: sortingProp, order: sortingOrder }" @sort-change="handleSortChange"
						@select-change="handleSelectChange" :show-summary="showSummary"
						:shown-pagination="shownPagination">


						<v2-table-column label="Sender " prop="senderName" sortable align="left"
							:fixed="isMobile ? '' : 'left'" width="200"></v2-table-column>
						<v2-table-column label="Reciever" prop="revieverName" sortable align="left"
							:fixed="isMobile ? '' : 'left'" width="200"></v2-table-column>
						<v2-table-column label="ref_Number" prop="referenceNumber" sortable align="left"
							:fixed="isMobile ? '' : 'left'" width="150"></v2-table-column>
						<v2-table-column label="Amount" prop="receiverAmount" sortable align="left"
							:fixed="isMobile ? '' : 'left'" width="200"></v2-table-column>
						<v2-table-column label="commision" prop="commision" align="left" width="100"
							:fixed="isMobile ? '' : 'left'" sortable></v2-table-column>

						<v2-table-column label="tranDate" prop="tranDate" sortable align="center"
							width="170"></v2-table-column>
						<v2-table-column label="partner" prop="partner" sortable width="200"></v2-table-column>
						<v2-table-column label="serviceProvider" prop="serviceProvider" sortable align="center"
							width="100"></v2-table-column>
						<v2-table-column label="Reason" prop="transactionReason" sortable width="200"></v2-table-column>

					</component><!-- v2-table -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'Ledgers',
	methods: {
		downloadData() {
			this.getSmallWorldReport()
				.then(result => {
					if (result.items)
						this.downloadCSV(result.items.map(p => {
							var l = {
								SENDER: p.senderName,
								RECIEVER: p.revieverName,
								REFERENCE_NUMBER: p.referenceNumber,
								AMOUNT: p.receiverAmount,
								COMMISSION: p.commision,

								DATE: p.tranDate,
								PARTNER: p.partner,
								SERVICEPROVIDER: p.serviceProvider,
								TRANSACTIONREASON: p.transactionReason

							}

							return l;
						}));
				})
				.catch(err => this.errorMessage('Error downloading data.'));
		},

		refreshLedgers() {
			this.getSmallWorldReport()
				.then(result => this.tableRefreshed(result))
				.catch(err => this.tableRefreshed(this.defaultListResult));
		}
	},
	created() {
		this.deleteEvent = 'deleteSelectedLedger';
		this.refreshListEvent = 'refreshLedgers';
		this.$on(this.refreshListEvent, this.refreshLedgers);
		this.$on(this.deleteEvent, this.deleteSelectedLedger);

		this.refreshLedgers();
	},
	mixins: [PermissionsMixins]
}
</script>